import { FC } from 'react'
import CustomSortBy from '../CustomSortBy'

interface props {
  indexName: string
  defaultIndex?: string
}

const AlgoliaSortingSelector: FC<props> = ({ indexName }) => {
  return (
    <CustomSortBy
      defaultRefinement={`${indexName}_published_at_desc`}
      items={[
        {
          value: `${indexName}_published_at_desc`,
          label: 'Newest',
        },
        {
          value: `${indexName}_recently_ordered_count_desc`,
          label: 'Popularity',
        },
        {
          value: `${indexName}_discount_ratio_desc`,
          label: 'Discount (Biggest – Smallest)',
        },
        {
          value: `${indexName}_price_desc`,
          label: '$ High – Low',
        },
        {
          value: `${indexName}_price_asc`,
          label: '$ Low – High',
        },
      ]}
    />
  )
}

export default AlgoliaSortingSelector
